import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { Guarantee } from '../models/guarantee';
import { GuaranteeRequestAttachment } from '../models/guarantee-request-attachment';
import { GuaranteeRequestService } from '../services/guarantee-request.service';

export const guaranteeRequestResolver: ResolveFn<Guarantee> = async (route: ActivatedRouteSnapshot) => {
	const guaranteeService = inject(GuaranteeRequestService);

	// To be implemented further for edit functionality..
	const params = <{ guaranteeId?: string }> route.params;
	const guaranteeIdParam = params['guaranteeId'];

	if (guaranteeIdParam && guaranteeService.guarantee.id !== guaranteeIdParam) {
		const guaranteeObj = await firstValueFrom(guaranteeService.getGuaranteeById(guaranteeIdParam));
		guaranteeService.guarantee = new Guarantee();
		Object.assign(guaranteeService.guarantee, guaranteeObj);
		const { results } = await firstValueFrom(guaranteeService.getAllAttachments(guaranteeIdParam));

		const createAttachment = (result: GuaranteeRequestAttachment): GuaranteeRequestAttachment => {
			const attachment = new GuaranteeRequestAttachment();
			attachment.metaData.mimeType = result.metaData.mimeType;
			attachment.chronicleId = result.chronicleId;
			attachment.versionId = result.versionId;
			attachment.creationDateTime = result.creationDateTime;
			attachment.name = result.name;
			attachment.size = result.size;
			attachment.metaData.guaranteeId = result.metaData.guaranteeId;
			attachment.metaData.environment = result.metaData.environment;
			attachment.metaData.type = result.metaData.type;
			attachment.type = result.metaData.mimeType;
			return attachment;
		};

		for (const result of results) {
			if (result.metaData.environment === 'STU') {
				guaranteeService.guarantee.attachments.push(createAttachment(result));
			} else if (result.metaData.type === 'Other' && result.metaData.environment === 'CRM') {
				guaranteeService.guarantee.crmAttachments.push(createAttachment(result));
			} else if (result.metaData.type === 'Certificate' && result.metaData.environment === 'CRM') {
				guaranteeService.guarantee.certificates.push(createAttachment(result));
			}
		}
		guaranteeService.guarantee.certificates.sort(
			(left, right) => {
				const leftTime = Date.parse(left.creationDateTime ?? '');
				const rightTime = Date.parse(right.creationDateTime ?? '');
				return (Number.isNaN(rightTime) ? 0 : rightTime) - (Number.isNaN(leftTime) ? 0 : leftTime);
			}
		);
	}
	return guaranteeService.guarantee;
};
